import { messageModel } from 'APP/model/model';
import Entities from 'STORE';

export async function readAllGroupsMessages(groupIds: string[]): Promise<void> {
  const groupsMessagesData: {
    groupId: string;
    lastMessageId: string;
    lastMessageTs: number;
    counter: number;
  }[] = [];

  groupIds.forEach((groupId) => {
    const group = Entities.GroupsStore.getGroupById(groupId);

    if (group?.counter?.lastMessage) {
      groupsMessagesData.push({
        groupId,
        lastMessageId: group.counter.lastMessage.id,
        lastMessageTs: group.counter.lastMessageTs,
        counter: group.counter.counter,
      });

      group.counter.counter = 0;
    }
  });

  try {
    if (groupsMessagesData.length) {
      const promises = groupsMessagesData.map(
        ({ groupId, lastMessageId, lastMessageTs, counter }) =>
          messageModel
            .confirmReadGroupMessages(groupId, lastMessageId)
            .then(() => Entities.pushNotifications.clearNotificationsByGroupId(groupId))
            .catch(() => {
              const groupCounter = Entities.GroupsStore.getGroupById(groupId)?.counter;
              if (groupCounter && groupCounter.lastMessageTs === lastMessageTs) {
                groupCounter.counter = counter;
              }
            })
      );

      await Promise.all(promises);
    }
  } catch {
    // do nothing
  }
}
